import React, { useState } from 'react';
import logo from "../assets/Superworq.png"
import classes from "./styles/navbar.module.css";
import {Link, useNavigate } from 'react-router-dom';
import menuIcon from "../assets/menu.png";

function Navbar({contactSection, faqSection,packageSection}) {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToContact = () => {
    const element = document.getElementById(contactSection);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }else{
      navigate("/");
      const delayImport = () => {
        const element2 = document.getElementById(contactSection);
        element2.scrollIntoView({ behavior: 'smooth' });
      };
      const timeoutId = setTimeout(() => {
        delayImport();
      }, 300);
      return () => clearTimeout(timeoutId);
    }
  };

  const scrollToFaq = () => {
    const element = document.getElementById(faqSection);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }else{
      navigate("/");
      const delayImport = () => {
        const element2 = document.getElementById(faqSection);
        element2.scrollIntoView({ behavior: 'smooth' });
      };
      const timeoutId = setTimeout(() => {
        delayImport();
      }, 300);
      return () => clearTimeout(timeoutId);
    }
  };

  const SrolltoPackage = () => {
    const element = document.getElementById(packageSection);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }else{
      navigate("/");
      const delayImport = () => {
        const element2 = document.getElementById(packageSection);
        element2.scrollIntoView({ behavior: 'smooth' });
      };
      const timeoutId = setTimeout(() => {
        delayImport();
      }, 300);
      return () => clearTimeout(timeoutId);
    }
  };

  const handleopenMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  }
  const handleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  }
  return (
  <>
  <div className={classes.Container}>
    <div className={classes.firstCon}>
        <Link to='/'><img src={logo} className={classes.logoImg} alt='superworq-logo'/></Link>
    </div>
    <div className={classes.secondCon}>
        <Link to='/about'>About</Link>
        <div className={classes.dropdown}>
        <button onClick={handleopenMenu} className={classes.serviceTitle}>Services</button>
        {isMenuOpen && <div className={classes.services}>
          <Link to='/wordpress-website-maintenance'>Maintenance</Link>
          <Link to='/wordpress-website-modification'>Modification</Link>
          <Link to='/wordpress-website-seo'>SEO</Link>
        </div>}
        </div>
        <button onClick={scrollToContact}>Contact</button>
        <button onClick={SrolltoPackage}>Pricing</button>
        <button onClick={scrollToFaq}>FAQ</button>
    </div>
  <div className={classes.secondConMobile}>
    <div onClick={handleMobileMenu} className={classes.menuIcon}><img src={menuIcon} alt='hamburger-icon'/></div>
  {isMobileMenuOpen && <div className={classes.dropdownMobile}>
        <Link to='/about'>About</Link>
        <Link to='/wordpress-website-maintenance'>Maintenance</Link>
        <Link to='/wordpress-website-modification'>Modification</Link>
        <Link to='/wordpress-website-seo'>SEO</Link>
        <button onClick={scrollToContact}>Contact</button>
        <button onClick={SrolltoPackage}>Pricing</button>
        <button onClick={scrollToFaq}>FAQ</button>
    </div>}
  </div>
  </div>
  </>
);
}

export default Navbar;